export enum PortalUsersErrors {
    PortalUserExist = 'already exists in the database',
    SelectedAccountExist = 'The selected account is already used by another individual.',
    PasswordError = 'The password must contain'
}
